import React, { useEffect } from "react";
import { Col, Container, Row } from "reactstrap";
import { Bloglistdata } from "../Data/Blogdata/Blogdata";
import AnimationCommon from "../common/AnimationCommon";
import CustomBreadcrumb from "../common/Breadcrumb";
import Paginationdata from "../common/Pagination";
import Footer from "../components/footer";
import BlogItem from "./BlogItem";
import BlogNav from "./BlogNav";

const BlogList = () => {
  useEffect(() => {
    document.body.classList.remove("landing-page");
    document.body.classList.add("inner-page");

    return () => {
      document.body.classList.remove("inner-page");
    };
  }, []);

  return (
    <div>
    <BlogNav/>
      <div className='page-margin'>
        <CustomBreadcrumb items={"Blog List"} />
        <section className='blog-page'>
          <Container>
            <Row>
              <Col sm={12}>
                <Row className='blog-list'>
                  {Bloglistdata.map((blog, index) => (
                    <BlogItem key={index} title={blog.title} author={blog.author} date={blog.date} commentsCount={blog.commentsCount} views={blog.views} content={blog.content} imageUrl={blog.imageUrl} detailsLink={blog.detailsLink} />
                  ))}
                </Row>
              </Col>
              <Paginationdata />
            </Row>
          </Container>
          <AnimationCommon />
        </section>
        <Footer />
      </div>
    </div>
  );
};

export default BlogList;
